import { render } from "./AddNewModal.vue?vue&type=template&id=0ef4f64e&scoped=true&ts=true"
import script from "./AddNewModal.vue?vue&type=script&lang=ts"
export * from "./AddNewModal.vue?vue&type=script&lang=ts"

import "./AddNewModal.vue?vue&type=style&index=0&id=0ef4f64e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef4f64e"]])

export default __exports__